// src/components/NotFoundPage.jsx
import React from 'react';
import { Message, Button, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <div className="login-container" style={{ flex: '1' }}>
                <div className="login-panel">
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                        <img src="/logo512.png" alt="tenantBridge" style={{ height: '56px', width: '56px' }} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                        <div style={{
                            fontSize: '72px',
                            fontWeight: '700',
                            color: '#e5e7eb',
                            lineHeight: '1',
                            letterSpacing: '-2px'
                        }}>
                            404
                        </div>
                    </div>

                    <Message info style={{ maxWidth: '100%', textAlign: 'center' }}>
                        <Message.Header style={{ fontSize: '1.25em', marginBottom: '0.5rem' }}>
                            Oops! Lost in Space
                        </Message.Header>
                        <p style={{ marginTop: '12px', marginBottom: 0 }}>
                            The page you're looking for has wandered off into the digital void. Let's get you back on track!
                        </p>
                    </Message>

                    <div className="login-actions" style={{ marginTop: '1.5rem', gap: '1rem', flexWrap: 'wrap' }}>
                        <Button 
                            primary 
                            icon 
                            labelPosition='left'
                            onClick={() => navigate('/')}
                            size='large'
                            style={{ minWidth: '160px' }}
                        >
                            <Icon name='home' />
                            Home
                        </Button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default NotFoundPage;

